var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99951 3.37518V8.71893",
    stroke: "#F27564",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3751 3.81325C13.4931 4.54082 14.3459 5.61017 14.8067 6.86191C15.2674 8.11364 15.3113 9.48075 14.9318 10.7595C14.5523 12.0382 13.7698 13.16 12.7009 13.9578C11.6319 14.7556 10.3338 15.1867 8.99999 15.1867C7.66615 15.1867 6.36803 14.7556 5.29909 13.9578C4.23015 13.16 3.44764 12.0382 3.06818 10.7594C2.68871 9.48072 2.73262 8.11362 3.19335 6.86188C3.65408 5.61014 4.50697 4.5408 5.62489 3.81323",
    stroke: "#F27564",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.e85e7898378d45ce4d3faa8e3b2bf10a.svg";
export { ForwardRef as ReactComponent };